import { render } from "./field.vue?vue&type=template&id=9c8e0c52"
import script from "./field.vue?vue&type=script&lang=js"
export * from "./field.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/field.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c8e0c52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c8e0c52', __exports__)) {
    api.reload('9c8e0c52', __exports__)
  }
  
  module.hot.accept("./field.vue?vue&type=template&id=9c8e0c52", () => {
    api.rerender('9c8e0c52', render)
  })

}


export default __exports__